import {
  buildFiveNineProactiveChatParams,
  buildFiveNineProfileList,
  buildFiveNineStandardChatParams
} from "./fiveNineSetup";
import {awaitApi} from "../../Utility/services";
import UrlBuilder from "../../lib/UrlBuilder";

globalThis.fiveNineStatus ||= {scriptVersion: "0429"};

export function tryInitFiveNineStandardChat({config, pageInfo}) {
  return awaitApi({
    getApi: () => globalThis.Five9SocialWidget,
    callback: api => initFiveNineStandardChat({api, config, pageInfo})
  });
}

export function tryInitFiveNineProactiveChat({config, pageInfo}) {
  return awaitApi({
    getApi: () => globalThis.Five9ProactiveChat,
    callback: api => initFiveNineProactiveChat({api, config, pageInfo})
  });
}

export function initFiveNineStandardChat({api, config, pageInfo}) {
  api ||= globalThis.Five9SocialWidget;

  let params = buildFiveNineStandardChatParams({api, config, pageInfo});
  globalThis.fiveNineStatus.standardParams = Object.assign({}, params);

  console.warn("INIT 59 STANDARD - ", params);
  api.addWidget(params);
}

export function initFiveNineProactiveChat({api, config, pageInfo}) {
  api ||= globalThis.Five9ProactiveChat;

  let params = buildFiveNineProactiveChatParams({api, config, pageInfo});
  let profiles = buildFiveNineProfileList({api, config, pageInfo, proactive: true});
  let profile = profiles[0];

  fiveNineStatus.proactiveParams = params;

  api.init(params);
  api.startNewPage({
    pageId: "", // document.location?.pathname,
    profiles: profile
  });
  console.log(`FIVE 9 PROACTIVE is initialized with profile: ${profile}`)
}
